import maleNames from '@/data/male-names.json';
import femaleNames from '@/data/female-names.json';
import lastNames from '@/data/last-names.json';
import rut from './rut';
import number from '@/helpers/number';

export const getRandomGender = () => {
    const genders = ['male', 'female'];
    return genders[number.randomIntFromInterval(0, 1)];
};

export const getRandomName = () => {
    const generate = (gender = getRandomGender()) => {
        if (gender === 'male') {
            const entriesCount = maleNames.data.length;
            return maleNames.data[
                number.randomIntFromInterval(0, entriesCount - 1)
            ];
        }

        if (gender === 'female') {
            const entriesCount = femaleNames.data.length;
            return femaleNames.data[
                number.randomIntFromInterval(0, entriesCount - 1)
            ];
        }

        return '';
    };

    return generate();
}


export const getRandomLastname = () => {
    const generate = () => {
        const entriesCount = lastNames.data.length;
        return lastNames.data[number.randomIntFromInterval(0, entriesCount - 1)];
    };

    return generate();
}

export const getRandomRut = () => {
    return rut.random();
}

export const showJSONData = (json) => {
    return <pre><code>{JSON.stringify(json, null, 4)}</code></pre>
}

export default { getRandomName, getRandomLastname, getRandomRut, getRandomGender, showJSONData };